import React, { useState } from "react";
import { MimaText, Modal } from "../../../components";
import P2PBuyerInfo from "./P2PBuyerInfo";
import P2PSellerInfo from "./P2PSellerInfo";
import OrderTracker from "./OrderTracker";

const ViewMoreP2PInfo = ({ singleItem, closeModal }) => {
  const [isBuyer, setIsBuyer] = useState(true);

  return (
    <Modal closeModal={closeModal}>
      <div style={{ width: "40rem" }}>
        <OrderTracker item={singleItem} />
        <MimaText variant="h3" align="center" mb={3} mt={3}>
          P2P Transaction Info
        </MimaText>
        <div className="modal__switcher">
          <div
            className={`modal__switcher__a ${
              isBuyer ? "modal__switcher__active" : ""
            }`}
            onClick={() => {
              setIsBuyer(true);
            }}
          >
            Buyer Details
          </div>
          <div
            className={`modal__switcher__b ${
              !isBuyer ? "modal__switcher__active" : ""
            }`}
            onClick={() => {
              setIsBuyer(false);
            }}
          >
            Seller Details
          </div>
        </div>

        {isBuyer ? (
          <P2PBuyerInfo singleItem={singleItem} />
        ) : (
          <P2PSellerInfo singleItem={singleItem} />
        )}
      </div>
    </Modal>
  );
};
export default ViewMoreP2PInfo;
